import { useParams, useNavigate } from 'react-router-dom';
import {
  Box, Card, CardContent, CardHeader, Grid, Typography,
  Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Button, Divider, CircularProgress,
  Dialog, DialogTitle, DialogContent, DialogActions, TextField
} from '@mui/material';
// import { useResponsablesConNombre } from "@/shared/actions";

import { useFetchGetByIdCambioService, useFetchHistorialCambioFiltrado } from '@/shared/actions/controlcambios/cambio-service.actions';
import { ROUTER_PATHS } from '@/shared';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation } from 'react-router-dom';
import { useFetchAprobacionesPorCambio, useFetchResponderAprobacion } from '@/shared/actions/controlcambios/aprobacion-service.actions';
import { useAuthStore } from '@/store/auth';
import { SectionCard } from '../../hooks';

import HistoryIcon from '@mui/icons-material/History';
import { useState } from 'react';
import { HistorialCambioModal } from '../../components';


export default function VerCambiosServicePage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  //
  const [historialOpen, setHistorialOpen] = useState(false);
  //
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;
    //historial del cambio
  const { data: historial, isLoading:isLoading_historial } = useFetchHistorialCambioFiltrado(id!,"APROBACION_RESPONDIDA" ,true);
  console.log("DATOS HISTORIAL", historial);
  const respuestas = historial ?? [];
  const { data: cambio, isLoading } = useFetchGetByIdCambioService(id!);
  //
    const { data: aprobResp } = useFetchAprobacionesPorCambio(id!);
    console.log("DATA APROBACION: ", aprobResp);
    const aprobaciones = aprobResp ?? [];   // ajusta si el envelope difiere
    console.log("DATA APROBACIONES",aprobaciones);

    /// RECHAZOS
    const rechazos = aprobaciones.filter(
      (a: any) => a.estadoAprobacion === 'RECHAZADO'
    );
/// Implementando 
const usuarioId = useAuthStore(s => s.user?.user_id);
const respondMutation = useFetchResponderAprobacion();

const [dialogOpen, setDialogOpen] = useState(false);
const [selectedId, setSelectedId] = useState<string | null>(null);
const [accion, setAccion] = useState<'APROBADO' | 'RECHAZADO'>('APROBADO');
const [comentario, setComentario] = useState('');

const abrirDialog = (id: string, ac: 'APROBADO' | 'RECHAZADO') => {
  setSelectedId(id); setAccion(ac); setComentario(''); setDialogOpen(true);
};
const confirmar = () => {
  if (!selectedId) return;
  respondMutation.mutate({ id: selectedId, data: { estadoAprobacion: accion, comentario } });
  setDialogOpen(false);
};

const getComentario = (detalle:string) => {
                  const idx = detalle.indexOf('Comentario:');
                  return idx !== -1 ? detalle.substring(idx) : detalle;
                };
const getNombre = (detalle: string) => {
  const match = detalle.match(/^(.*?)\s+(?:APROBÓ|RECHAZÓ)/i);
  return match ? match[1].trim() : 'Usuario no disponible';
};


  //
  if (isLoading) return <CircularProgress sx={{ display: 'block', mx: 'auto', mt: 4 }} />;
  if (!cambio) return <Typography>No se encontró el cambio</Typography>;

  return (
    <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
       <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(from ?? ROUTER_PATHS.control_cambios.cambioServicenav)}
          sx={{ mb: 2 }}
        >
          Volver
        </Button>
        <Button
            startIcon={<HistoryIcon />}
            variant="outlined"
            color="secondary"
            onClick={() => setHistorialOpen(true)}
          >
            Ver historial
          </Button>
       </Box>

       <HistorialCambioModal
          open={historialOpen}
          onClose={() => setHistorialOpen(false)}
          cambioId={id!}
          codigoCambio={cambio?.codigo}
        />

      {/* DATOS GENERALES */}
      <Card sx={{ mb: 3 }}>
        <CardHeader title="Datos Generales" />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="text.secondary">Código</Typography>
              <Typography variant="body1" fontWeight={600}>{cambio.codigo}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="text.secondary">Título</Typography>
              <Typography variant="body1">{cambio.titulo}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="text.secondary">Tipo de Cambio</Typography>
              <Typography variant="body1">{cambio.tipoCambio}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="text.secondary">Solicitante</Typography>
              <Typography variant="body1">{cambio.solicitante || '-'}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="text.secondary">Estado</Typography>
              <Chip label={cambio.estado} color={cambio.estado === 'APROBADO' ? 'success' : 'default'} />
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="text.secondary">Prioridad</Typography>
              <Typography variant="body1">{cambio.prioridad}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="text.secondary">Impacto</Typography>
              <Typography variant="body1">{cambio.impacto}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="text.secondary">Riesgo</Typography>
              <Typography variant="body1">{cambio.riesgo}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="text.secondary">Usuario Creación</Typography>
              <Typography variant="body1">{cambio.usuarioCreacion}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">Descripción</Typography>
              <Typography variant="body1">{cambio.descripcion}</Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {/*prueba */}
      {respuestas.length > 0 && (
        <Card sx={{ mb: 3, borderLeft: '4px solid #2fb2d3' }}>
          <CardHeader title="Respuestas de usuarios" />
          <CardContent>
            <Grid container spacing={2}>
              {respuestas.map(h => {
                  const md =
                    respuestas.length === 1
                      ? 12
                      : respuestas.length === 2
                      ? 6
                      : 4;

                return(
                <Grid item xs={12} md={md} key={h.historialCambioId}>
                  <Box sx={{ mb: 2, padding: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1, height: '100%' }}>
                    <Typography variant="subtitle2"  fontWeight={600}>
                      {/* {h.usuario} */}
                      {getNombre(h.detalle)}
                    </Typography>
                    
                          
                    {h.detalle.includes("APROBÓ") ? (
                      <Typography variant="subtitle2" fontWeight={600}>
                        Estado: Aprobado
                      </Typography>
                    ) : (
                      <Typography variant="subtitle2" fontWeight={600}>
                        Estado: Rechazado
                      </Typography>
                    )}
                    
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      <b>Comentario:</b>{getComentario(h.detalle).replace('Comentario:', '')}
                    </Typography>
                    <Typography variant="caption" color="text.disabled" display="block" sx={{ mt: 1 }}>
                      {new Date(h.fecha).toLocaleString()}
                    </Typography>
                  </Box>
                </Grid>
                );
              })}
            </Grid>
          </CardContent>
        </Card>
      )}
         {/* DATOS RECHAZADOS */}
      {/* {(cambio.estado?.toUpperCase() === 'RECHAZADO' || cambio.estado?.toUpperCase() === 'CANCELADO') && rechazos.length > 0 && (
          <Grid item xs={12} md={4}>

            <Card sx={{ mb: 3, borderLeft: '4px solid #d32f2f' }}>
              <CardHeader title="Motivo del rechazo" />
              <CardContent>
                 <Grid container spacing={2}>
                  {rechazos.map((a: any) => {
                    const nombre = a.razonSocial ?? "No disponible";
                    
                    const md =
                    rechazos.length === 1
                      ? 12
                      : rechazos.length === 2
                      ? 6
                      : 4;
                    return (
                      <Grid item xs={12} md={md} key={a.aprobacionId}>

                        <Box key={a.aprobacionId} sx={{ mb: 2, border: '1px solid',
                          borderColor: 'divider',
                          borderRadius: 2,
                          height: '100%', }}>
                          <Typography variant="subtitle2" fontWeight={600}>
                            {nombre}{a.area?.nombre ? ` — ${a.area.nombre}` : ''}
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{mt:1}}>
                            {a.comentario || 'Sin comentario'}
                          </Typography>
                          {a.fechaRespuesta && (
                            <Typography variant="caption" color="text.disabled" display="block"
                sx={{ mt: 1 }}>
                              {new Date(a.fechaRespuesta).toLocaleString()}
                            </Typography>
                          )}
                        </Box>
                      </Grid> 
                    );
                  })}

                 </Grid>
              </CardContent>
            </Card>
          </Grid>

        )} */}


      {/* FECHAS */}
      <Card sx={{ mb: 3 }}>
        <CardHeader title="Fechas" />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <Typography variant="caption" color="text.secondary">Fecha Programada</Typography>
              <Typography variant="body1">{cambio.fechaProgramada}</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <Typography variant="caption" color="text.secondary">Hora Programada</Typography>
              <Typography variant="body1">{cambio.horaProgramada}</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <Typography variant="caption" color="text.secondary">Duración</Typography>
              <Typography variant="body1">{cambio.duracion}</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <Typography variant="caption" color="text.secondary">Fecha Creación</Typography>
              <Typography variant="body1">{new Date(cambio.fechaCreacion).toLocaleString()}</Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* SERVICIOS AFECTADOS */}
      {cambio.serviciosAfectados?.length > 0 && (
        <Card sx={{ mb: 3 }}>
          <CardHeader title="Servicios Afectados" />
          <CardContent>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Tiempo Afectación</TableCell>
                    <TableCell>Cliente</TableCell>
                    <TableCell>Servicio</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cambio.serviciosAfectados.map(s => (
                    <TableRow key={s.servicioAfectadoId}>
                      <TableCell>{s.tiempoAfectacion}</TableCell>
                      <TableCell>{s.clienteAfectado}</TableCell>
                      <TableCell>{s.servicio}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}
      { (cambio.metricas?.length ?? 0) > 0 && (
        <Card sx={{ mb: 3 }}>
          <CardHeader title="Metricas" />
          <CardContent>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Cumplimiento</TableCell>
                    <TableCell>observacion</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(cambio.metricas ?? []).map(s => (
                    <TableRow key={s.metricaId}>
                      <TableCell>{s.descripcion}</TableCell>
                      <TableCell>{s.cumplido ? "Si" : "No"}</TableCell>
                      <TableCell>{s.observacion}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      {/* PLAN DE ACCIÓN */}
      {cambio.planAccion?.length > 0 && (
        <Card sx={{ mb: 3 }}>
          <CardHeader title="Plan de Acción" />
          <CardContent>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Acción</TableCell>
                    <TableCell>Responsable</TableCell>
                    <TableCell>Fecha</TableCell>
                    <TableCell>Observación</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cambio.planAccion.map(p => (
                    <TableRow key={p.planAccionId}>
                      <TableCell>{p.accion}</TableCell>
                      <TableCell>{p.responsable}</TableCell>
                      <TableCell>{p.fecha}</TableCell>
                      <TableCell>{p.observacion}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      {/* RIESGOS */}
      {cambio.riesgos?.length > 0 && (
        <Card sx={{ mb: 3 }}>
          <CardHeader title="Análisis de Riesgos" />
          <CardContent>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Descripción</TableCell>
                    <TableCell>Impacto</TableCell>
                    <TableCell>Probabilidad</TableCell>
                    <TableCell>Tipo Riesgo</TableCell>
                    <TableCell>Contingencia</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cambio.riesgos.map(r => (
                    <TableRow key={r.riesgoCambioId}>
                      <TableCell>{r.descripcion}</TableCell>
                      <TableCell>{r.impacto}</TableCell>
                      <TableCell>{r.probabilidad}</TableCell>
                      <TableCell>{r.tipoRiesgo}</TableCell>
                      <TableCell>{r.accionContingencia}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      {/* ROLLBACK */}
      {cambio.rollbackActividades?.length > 0 && (
        <Card sx={{ mb: 3 }}>
          <CardHeader title="Plan de Retorno (Rollback)" />
          <CardContent>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>N°</TableCell>
                    <TableCell>Actividad</TableCell>
                    <TableCell>Duración</TableCell>
                    <TableCell>Responsable</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cambio.rollbackActividades.map(rb => (
                    <TableRow key={rb.rollbackActividadId}>
                      <TableCell>{rb.numero}</TableCell>
                      <TableCell>{rb.actividad}</TableCell>
                      <TableCell>{rb.duracion}</TableCell>
                      <TableCell>{rb.responsable}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}
      {aprobaciones.length > 0 && (
  <SectionCard>
    <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1, textTransform: "uppercase" }}>
      Autorización del cambio / mantenimiento
    </Typography>
    <Divider sx={{ mb: 2 }} />
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Aprobador</TableCell>
          <TableCell>Rol</TableCell>
          <TableCell>Estado</TableCell>
          <TableCell align="center">Acciones</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {aprobaciones.map((a: any) => {
            const esMiAprobacion =
              Number(a.usuarioId) === Number(usuarioId) &&
              a.estadoAprobacion === 'PENDIENTE';

            return (
              <TableRow key={a.aprobacionId}>
                <TableCell>{a.razonSocial}</TableCell>
                <TableCell>{a.rol}</TableCell>
                <TableCell>{a.estadoAprobacion}</TableCell>
                <TableCell align="center">
                  {esMiAprobacion ? (
                    <Grid container spacing={1} justifyContent="center">
                      <Grid item>
                        <Button size="small" variant="contained" color="success"
                          onClick={() => abrirDialog(a.aprobacionId, 'APROBADO')}>
                          Aprobar
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button size="small" variant="contained" color="error"
                          onClick={() => abrirDialog(a.aprobacionId, 'RECHAZADO')}>
                          Rechazar
                        </Button>
                      </Grid>
                    </Grid>
                  ) : '—'}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </SectionCard>
  )}
  <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
    <DialogTitle>{accion === 'APROBADO' ? 'Aprobar' : 'Rechazar'} aprobación</DialogTitle>
    <DialogContent>
      <TextField autoFocus multiline rows={3} label="Comentario" fullWidth
        value={comentario} onChange={e => setComentario(e.target.value)} sx={{ mt: 1 }} />
    </DialogContent>
    <DialogActions>
      <Button onClick={() => setDialogOpen(false)}>Cancelar</Button>
      <Button variant="contained" color={accion === 'APROBADO' ? 'success' : 'error'}
        onClick={confirmar} disabled={!comentario.trim()}>
        {accion === 'APROBADO' ? 'Aprobar' : 'Rechazar'}
      </Button>
    </DialogActions>
  </Dialog>
    </Box>
  );
}